import { takeLeading } from "@redux-saga/core/effects";

import { FormsActionTypes } from "../types";
import { getFormSaga } from "./getFormSaga";
import { getFormsSaga } from "./getFormsSaga";
import { createFormSaga } from "./createFormSaga";
import { updateFormNameSaga } from "./updateFormNameSaga";
import { getUserFontsSaga } from "./getUserFontsSaga";
import { saveChangedFontsSaga } from "./saveChangedFonts";
import { updateFormStyles } from "./updatePageStyles";
import { newUpdateBackgroundSaga } from "./updateBackgroundStyles";
import { updateFormButtonsDataSaga } from "./updateSubmitButtonStylesSaga";
import { transferFormSaga } from "./transferFormSaga";
import { transferWixSubmiisonsSaga } from "./transferSubmissionsSaga";

export default function* formsSaga() {
    yield takeLeading(FormsActionTypes.GET_FORM_REQUEST, getFormSaga);
    yield takeLeading(FormsActionTypes.GET_FORMS_REQUEST, getFormsSaga);
    yield takeLeading(FormsActionTypes.CREATE_FORM_REQUEST, createFormSaga);
    yield takeLeading(FormsActionTypes.GET_USER_FONTS_REQUEST, getUserFontsSaga);
    yield takeLeading(FormsActionTypes.UPDATE_FORM_NAME_REQUEST, updateFormNameSaga);
    yield takeLeading(FormsActionTypes.SAVE_CHANGED_FONTS_REQUEST, saveChangedFontsSaga);
    yield takeLeading(FormsActionTypes.UPDATE_FORM_BACKGROUND_REQUEST, newUpdateBackgroundSaga);
    yield takeLeading(FormsActionTypes.UPDATE_FORM_PAGE_STYLES_REQUEST, updateFormStyles);
    yield takeLeading(FormsActionTypes.UPDATE_FORM_BUTTONS_DATA_REQUEST, updateFormButtonsDataSaga);
    yield takeLeading(FormsActionTypes.TRANSFER_FORM , transferFormSaga);
    yield takeLeading(FormsActionTypes.TRANSFER_FORM_SUBMISSIONS , transferWixSubmiisonsSaga)
}
